
import CalendarOriginalProviders from '@/entities/CalendarOriginalProviders'
import CalendarOriginalLocations from '@/entities/CalendarOriginalLocations'
import CalendarBorrowedProviders from '@/entities/CalendarBorrowedProviders'
import CalendarBorrowedLocations from '@/entities/CalendarBorrowedLocations'
import CalendarSettings from '@/entities/CalendarSettings'
import CalendarDisplayInfo from '@/entities/CalendarDisplayInfo'
import CalendarSortingInfo from '@/entities/CalendarSortingInfo'
import { CALENDAR_TYPES } from '@/views/constants'

export default class Calendar {
  constructor (options = { location_id: 0, provider_id: 0 }) {
    this.type = options?.type ?? CALENDAR_TYPES.PRACTICE_TYPE
    this.index = `${options.provider_id}_${options.location_id}`
    this.providerId = options.provider_id
    this.locationId = options.location_id
    this.id = options.id || null
    this.scheduleId = options.schedule_id || null

    this.originalProviders = new CalendarOriginalProviders(options, this.providerId, this.type)
    this.originalLocations = new CalendarOriginalLocations(options, this.locationId, this.type)
    this.settings = new CalendarSettings(options)
    // this data will be added from other endpoint through store mutations
    this.additionalData = {
      insurances: [],
      reasons: []
    }
    this.timeBlocks = {}
    this.borrowedProviders = new CalendarBorrowedProviders(this)
    this.borrowedLocations = new CalendarBorrowedLocations(this)
    this.borrowedProviderId = null
    this.borrowedPLocationId = null
    // will be updated after borrowedProviders and borrowedLocations collecting
    this.displayInfo = new CalendarDisplayInfo(this, options)
    // depend on displayInfo
    this.sortingInfo = new CalendarSortingInfo(this)
  }
}

/*
entity example
const Calendar = {
  // base info
  originalProviders: {
    list: [],
    current: {}
  }, new CalendarOriginalProviders
  originalLocations: {
    list: [],
    current: {}
  }, new CalendarOriginalLocations
  settings: {
    communication: {}, new CalendarCommunicationSettings
    fields: {}, new FieldsSettings
    skipProviderSelection: false,
    externalCalendarSource: '',
    allowNoInsAnswer: false,
    screeningSettings: '',
  },
  additionalData: {
    insurances: [],
    reasons: [],
  },
  timeBlocks: {},
  type: 'provider_location',
  providerId: 1, // original provider id
  locationId: 2, // original location id
  scheduleId: 'schedule_uuid',
  id: 21332,
  sortIndex: 1000,
  // complex info which can be calculated only after base info was created for all calendars
  borrowedProviders: {
    list: [],
    current: []
  }, new CalendarBorrowedProviders
  borrowedLocations: {
    list: [],
    current: {}
  }, new CalendarBorrowedLocations
  borrowedProviderId: null,
  borrowedLocationId: null,
  displayInfo: {
    displayProviders: {},new CalendarOriginalProviders or CalendarBorrowedProviders
    displayLocations: {}, new CalendarOriginalLocations
    image: '',
    providerName: '', // based on borrowed if exist or original if not
    locationName: '', // based on original
    address: {},
    name: '', // based on borrowed if exist or original if not
    specialty: '', // based on original
    phoneFormatted: '',
    phone: '',
    label: '',
    footerText: '',
  },
  sortingInfo: {}, // CalendarSortingInfo
}
 */
